import { useEffect } from "react";
import { Toast, ToastBody } from "reactstrap";
import { X } from "react-bootstrap-icons";
import { toastTimeoutMs } from "../../constants/toast";

export const ToastMessage = ({ Message = "", ToggleCallback, Type = "info" }) => {
    const classesPerType =
        "position-absolute top-0 right-1 p-3 rounded zindex-popover toast-message";

    let bodyClass = "rounded toast-body-custom ";

    switch (Type) {
        case "success":
            bodyClass += "toast-body-success";
            break;
        case "error":
            bodyClass += "toast-body-error";
            break;
        case "warning":
            bodyClass += "toast-body-warning";
            break;
        default:
            bodyClass += "toast-body-info";
            break;
    }

    useEffect(() => {
        const id = setTimeout(() => {
            ToggleCallback();
        }, toastTimeoutMs);

        return () => clearTimeout(id);
    }, [ToggleCallback]);

    return (
        <Toast isOpen={true} className={`no-toast-wrapper ${classesPerType}`}>
            <ToastBody className={bodyClass}>
                <div className="d-flex justify-content-between align-items-start">
                    <div>{Message?.substring(0, 200)}</div>

                    <button
                        type="button"
                        onClick={ToggleCallback}
                        aria-label="Close"
                        className="border-0 bg-transparent p-0 ms-3"
                        style={{ lineHeight: 0 }}
                    >
                        <X size={20} color="white" />
                    </button>
                </div>
            </ToastBody>
        </Toast>
    );
};

